import { useQuery } from '@tanstack/react-query';
import { CustomerCampaignMessageHistory } from '../model/CampaignApiTypes';
import ApiAgent, { handleError } from '@/common/agent/ApiAgent';

export function queryKey(customer_id?: string) {
  return ['message', 'history', customer_id] as const;
}

interface CampaignMessageHistoryRes {
  items: CustomerCampaignMessageHistory[];
}

export const useGetCustomerCampaignMessageHistory = (customer_id?: string) => {
  return useQuery<CustomerCampaignMessageHistory[]>({
    queryKey: queryKey(customer_id),
    queryFn: async () => {
      try {
        const response = await ApiAgent.get<CampaignMessageHistoryRes>(`/message/history`, {
          params: { cus_cd: customer_id },
        });
        return response.data.items;
      } catch (error) {
        handleError(error);
        throw error;
      }
    },
    enabled: !!customer_id,
  });
};
